/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchOrgTree } from "../service/orgTreeService";
import type { ApiOrganization, ApiIndependentInstitution, Pagination } from "../types";

const EMPTY_PAGINATION: Pagination = { page: 1, limit: 20, total: 0, totalPages: 0 };

interface OrgTreeState {
  organizations: ApiOrganization[];
  independents: ApiIndependentInstitution[];
  pagination: Pagination;
  independentsPagination: Pagination;
  page: number;
  limit: number;
  loading: boolean;
  error: string;
}

const initialState: OrgTreeState = {
  organizations: [],
  independents: [],
  pagination: EMPTY_PAGINATION,
  independentsPagination: EMPTY_PAGINATION,
  page: 1,
  limit: 20,
  loading: false,
  error: "",
};

export const loadOrgTree = createAsyncThunk(
  "orgTree/load",
  async ({ page, limit }: { page: number; limit: number }, { rejectWithValue }) => {
    try {
      return await fetchOrgTree({ page, limit });
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.error || "Failed to load organizations.");
    }
  }
);

const orgTreeSlice = createSlice({
  name: "orgTree",
  initialState,
  reducers: {
    setPage(state, action: { payload: number }) {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadOrgTree.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(loadOrgTree.fulfilled, (state, action) => {
        state.loading = false;
        state.organizations = action.payload.organizations ?? [];
        state.independents = action.payload.independentInstitutions ?? [];
        state.pagination = action.payload.pagination ?? EMPTY_PAGINATION;
        state.independentsPagination = action.payload.independentInstitutionsPagination ?? EMPTY_PAGINATION;
      })
      .addCase(loadOrgTree.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed to load organizations.";
      });
  },
});

export const { setPage } = orgTreeSlice.actions;
export default orgTreeSlice.reducer;
